
    import Vue from 'vue';
    import documentTypeService from '@/apps/shared/services/documentType-service';
    import clientByDocumentAndTypeService from '@/apps/shared/services/clientByDocumentAndType-service';
    import localityService from '@/apps/shared/services/locality-service';
    import CRMCotizadorWebService from '@/apps/shared/services/crm-service';
    import phoneValidateService from '@/apps/shared/services/phone-service';
    import searchPersonService from '@/apps/shared/services/searchPerson-service';
    export default Vue.extend({
        el: '#step1',
        name: 'TabOne',
        data() {
            return {
                localityList:
                    function (params) {
                        return localityService.getLocalityList(params)
                    },
                telephone: '',
                streetName: null,
                nacimiento: null,
                messageErrorAge: null,
                age: '0',
                stringDate: '',
                piso: null,
                numDom: null,
                numDept: null,
                areaCode: '',
                email: '',
                numDoc: null,
                selectedLocality: null,
                localityId: null,
                zipCode: null,
                documentTypeList: [{ id: "", text: "" }],
                MaximDigitSuperatedDni: false,
                isPersonExist: false,
                isNotSelectedDocumentType: true,
                docTypeSelected: null,
                maxSelections: 2,
                activeForm: false,
                minimumInputLength: 4,
                autocompleteConfig: {
                    formatResult: NF.Autocomplete.Result.TAGS,
                    selection: NF.Autocomplete.Result.TAGS,
                    minimumInputLength: 4
                },
                accept: true,
                DataPlan: null,
                planDescription: null,
                primerCuota: null,
                coberturasAmparo: [],
                gender: null,
                officeId: null,
                city: null,
                address: null,
                selectedIvaCondition: null,
                province: null,
                genderId: null,
                firstName: "",
                lastName: "",
                activeFormPersonNoExist: false,
                hasLocality: false,
                disable: true,
                validatePhone: false,
                messageErrorAreaCode: null,
                messageErrorPhone: null,
                messageError: null,
                messageErrorDigits: null,
                validDigits: null,
                numDocChange: null,
                numDocExisting: null,
                multiplePeopleWithSameIdentifier: [],
                personWithSameIdentifierSelected: null,
                clientId: null,
                lastDocumentTypeFromService: null,
                keepData: false,
                hasChangedDocumentTypeBefore: false,
                hasBupPerson: false,
                isPersonWithSharedDocumentNumber: false,
                addressList: null,
                referente: null,
                areaCodeTimeout: null,
                telephoneTimeout: null,
            }
        },

        created() {
            window.globalThis.validateNumDoc = (val) => {
                let valid = true
                let message = ""
                if (this.docTypeSelected.id == 'D') {
                    if (![7, 8].includes(val.length)) {
                        valid = false;
                        message = val.length > 0 ? "La cantidad de dígitos es incorrecta" : "Este campo es obligatorio.";
                        this.disable = true;
                    } else if (this.numDocExisting !== val) {
                        this.numDocChange = true;
                        this.numDocExisting = val;
                        this.disable = false;
                    }
                }
                else {
                    this.disable = false;
                }
                return { valid, message }
            };

            window.globalThis.validateLocality = function () {
                return Boolean(this.selectedLocality);
            }.bind(this);
        },

        methods: {
            onSelectedClient(id) {
                this.clientId = id;
                this.acceptSelectMultiplePeopleModal();
            },

            openSelectMultiplePeopleModal: function (peopleList) {
                this.isPeopleWithSameIdentifierModalOpen = true;
                this.resetMultiplePeopleModalValues();
                let idCounter = 1;
                // Inicializar el array multiplePeopleWithSameIdentifier
                this.multiplePeopleWithSameIdentifier = peopleList.map(person => {
                    let newPerson = {
                        id: idCounter++,
                        birthday: person.birthday,
                        firstName: person.firstName,
                        lastName: person.lastName,
                        email: person.email,
                        selectedIvaCondition: person.ivaConditionFiscalId,
                        areaCode: person.phoneAreaCode,
                        telephone: person.phoneNumber,
                        hasLocality: person.hasLocality,
                        address: null,
                        document: null
                    };
                    if (person.address != null && person.address != undefined) {
                        newPerson.address = {
                            cityId: person.address.cityId,
                            streetNumber: person.address.streetNumber,
                            streetName: person.address.streetName,
                            zipCode: person.address.zipCode,
                            floor: person.address.floor,
                            department: person.address.department
                        };
                    };
                    if (person.document != null && person.document != undefined) {
                        newPerson.document = person.document;
                    };
                    return newPerson;
                });
                this.$refs.selectMultiplePeopleModal.open();
            },

            resetMultiplePeopleModalValues() {
                this.multiplePeopleWithSameIdentifier = [];
                this.clientId = null;
            },

            closeSelectMultiplePeopleModal: function () {
                this.isPeopleWithSameIdentifierModalOpen = false;
                this.resetMultiplePeopleModalValues();
                this.$refs.selectMultiplePeopleModal.close();
            },

            acceptSelectMultiplePeopleModal() {
                let selectedPerson = this.multiplePeopleWithSameIdentifier.find(item => this.clientId == item.id);
                this.setPersonToCover(selectedPerson);
                searchPersonService.SetPerson(selectedPerson.lastName, selectedPerson.firstName)
                    .then(response => {
                        setTimeout(() => {
                            this.closeSelectMultiplePeopleModal();
                        }, 300);
                    })
                    .catch(error => {
                        this.getPersonByDocumentAndType();
                    });
            },

            setPersonToCover(personToCover) {
                let dataClientTabOne = JSON.parse(sessionStorage.getItem("TabOneWelcome"));
                this.activeFormPersonNoExist = false;
                this.isPersonExist = true;
                this.activeForm = true;
                this.nacimiento = personToCover.birthday;
                this.firstName = personToCover.firstName;
                this.lastName = personToCover.lastName;
                this.email = dataClientTabOne.email;
                this.areaCode = dataClientTabOne.areaCode;
                this.telephone = dataClientTabOne.telephone;
                this.hasLocality = personToCover.hasLocality;
                this.addressList = personToCover.address;
                this.isPersonWithSharedDocumentNumber = true;
                this.lastDocumentTypeFromService = personToCover.document.identificationTypeCode;
                this.keepData = true;
                this.hasBupPerson = true;
                this.docTypeSelected = this.documentTypeList.find(x => x.id == personToCover.document.identificationTypeCode);
                window.globalThis.dataLayer.push({
                    'pas': null,
                    'email': this.email,
                    'product': 'movilidad',
                    'event': 'cotizador-movilidad-dni',
                    'referente': this.referente
                });
            },

            searchPersonData() {
                this.streetName = null;
                this.piso = null;
                this.numDom = null;
                this.numDept = null;
                this.selectedLocality = null;
                this.getPersonByDocumentAndType();
            },

            getTelephoneValidation() {
                return new Promise<any>(async (resolve) => {
                    await this.validPhone();

                    const validateField = (field, message) => {
                        NF.Validation.Field.removeField("#form1", field);
                        NF.Validation.Field.addField("#form1", field, {
                            validators: {
                                stringLength: { message },
                            },
                        });
                        NF.Validation.Field.validate("#form1", field);
                    };
                    validateField("areaCode", this.messageErrorAreaCode);
                    validateField("telephone", this.messageErrorPhone);
                })
            },

            getFilePath() {
                this.Bus.$emit('redirectPlan');
            },

            validate: function (config, direction) {
                if (direction == "backward") {
                    this.getFilePath();
                    return true;
                }
                if (!this.numDocChange) {
                    const formIsValid = NF.Validation.Form.validate('#form1');
                    if (!formIsValid) return formIsValid;

                    if (!this.hasLocality && config.viewModel.selectedLocality == null) {
                        return false;
                    }
                    if (direction != "backward") {
                        sessionStorage.removeItem("stepOneData");
                        const { nacimiento, docTypeSelected, numDoc, areaCode, telephone, email, firstName, lastName, selectedLocality, streetName, piso, numDom, numDept, addressList } = config.viewModel;
                        var birthDay = new Date(nacimiento.toString());
                        var birthDayFormated = (birthDay.getFullYear() + '/' + (birthDay.getMonth() + 1 + '/' + birthDay.getDate()));
                        const zipCode = (!this.isPersonExist || !this.hasLocality) ? selectedLocality.zipCode : null;
                        const localityId = (!this.isPersonExist || !this.hasLocality) ? selectedLocality.id : null;
                        const address = addressList || (this.isPersonExist || this.hasLocality ? "" : `${selectedLocality.name} ${selectedLocality.zipCode}`);
                        sessionStorage.setItem("stepOneData", JSON.stringify({
                            documentType: docTypeSelected,
                            documentNumber: numDoc,
                            birthDay: birthDayFormated,
                            areaCode: areaCode,
                            telephone: telephone,
                            email: email,
                            firstName: firstName,
                            lastName: lastName,
                            zipCode: zipCode,
                            localityId: localityId,
                            streetName: streetName,
                            piso: piso,
                            numDom: numDom,
                            numDept: numDept,
                            address: address
                        }));
                        new Promise<any>(async (resolve) => {
                            resolve(this.validPhone());
                        });
                        return (this.age < 18 || !this.validatePhone) ? false : true;
                    }
                    return formIsValid;
                } else {
                    this.searchPersonData();
                    return false;
                }
            },

            createOrEditLead: function () {
                var leadId = JSON.parse(sessionStorage.getItem("LeadId"));
                CRMCotizadorWebService.CreateOrEditLead(this.leadId, this.email, location.href, this.areaCode, this.telephone, 936, false, "5", null, null, null);
            },

            validPhone: function () {
                if (this.telephone == "" && this.areaCode == "") {
                    this.validDigits = true;
                }
                return new Promise<any>(async (resolve) => {
                    await phoneValidateService.validatePhone(this.areaCode, this.telephone).then(o => {
                        const { areaCodeSuccess, phoneNumberSuccess, validCountDigit, message } = o;
                        if (!areaCodeSuccess) this.messageErrorAreaCode = message;
                        if (!phoneNumberSuccess) this.messageErrorPhone = message;
                        this.messageErrorDigits = validCountDigit === null ? "" : validCountDigit ? "" : message;
                        this.validatePhone = validCountDigit;
                        resolve(this.validatePhone);
                    });
                })
            },

            getDocumentType() {
                NF.UI.Page.block();
                documentTypeService.getDocumentTypeList().then(response => {
                    if (response.length != 0) {
                        this.documentTypeList = response.map(element =>
                            ({ ...element, id: element["id"], text: element["name"] }))
                        this.docTypeSelected = this.documentTypeList.find(p => p.name.trim() == "DNI");
                    }
                })
            },
            getPersonByDocumentAndType: function () {
                this.numDocChange = false;
                this.Bus.$emit('enableNextButton');
                this.activeFormPersonNoExist = false;
                this.hasLocality = false;
                var dataClientTabOne = this.DataPlan = JSON.parse(sessionStorage.getItem("TabOneWelcome"));
                NF.UI.Page.blockCustom({ message: 'Cargando datos..' });
                if (this.numDoc != "") {
                    var Dni = this.numDoc == null ? 0 : this.numDoc;
                    var DocTypeSeleccionado = this.docTypeSelected.name.trim();
                    searchPersonService.GetSearchPersonData(this.numDoc, this.docTypeSelected.id)
                        .then(response => {
                            if (response.searchPersonResult.length > 1) {
                                this.openSelectMultiplePeopleModal(response.searchPersonResult);
                                return;
                            }
                            let result = response.searchPersonResult[0];
                            if (result != undefined && (result && result.firstName != "" && result.lastName != "" || result.razonSocial != undefined)) {
                                this.activeFormPersonNoExist = false;
                                this.isPersonExist = true;
                                this.activeForm = true;
                                this.nacimiento = result.birthday;
                                this.firstName = result.firstName;
                                this.lastName = result.lastName;
                                this.email = dataClientTabOne.email;
                                this.areaCode = dataClientTabOne.areaCode;
                                this.telephone = dataClientTabOne.telephone;
                                this.hasLocality = result.hasLocality;
                                this.addressList = result.localityName;
                                this.isPersonWithSharedDocumentNumber = false;
                                this.lastDocumentTypeFromService = result.document.identificationTypeCode;
                                this.keepData = true;
                                this.hasBupPerson = true;
                                this.docTypeSelected = this.documentTypeList.find(x => x.id == result.document.identificationTypeCode);
                                window.globalThis.dataLayer.push({
                                    'pas': null,
                                    'email': this.email,
                                    'product': 'movilidad',
                                    'event': 'cotizador-movilidad-dni',
                                    'referente': this.referente
                                });
                            }
                            else {
                                this.activeForm = true;
                                this.isPersonExist = false;
                                this.firstName = dataClientTabOne.name;
                                this.email = dataClientTabOne.email;
                                this.areaCode = dataClientTabOne.areaCode;
                                this.telephone = dataClientTabOne.telephone;
                                this.age = "";
                                this.nacimiento = null;
                                this.lastName = dataClientTabOne.lastName;
                                this.activeFormPersonNoExist = true;
                                this.selectedLocality = null;
                                this.lastDocumentTypeFromService = null;
                                this.keepData = false;
                                this.hasBupPerson = false;
                                window.globalThis.dataLayer.push({
                                    'pas': null,
                                    'email': this.email,
                                    'product': 'movilidad',
                                    'event': 'errorUsuario',
                                    'paso': 'cotizador-movilidad-dni',
                                    'referente': this.referente
                                });
                            }
                            if (Dni.toString().length > 0 && Dni.toString().length < 9) {
                                this.MaximDigitSuperatedDni = false;
                                this.keepData = true;
                            }
                            else {
                                if (DocTypeSeleccionado == "DNI") {
                                    this.MaximDigitSuperatedDni = true;
                                    this.firstName = "";
                                    this.lastName = "";
                                    this.nacimiento = null;
                                    this.isPersonExist = true;
                                    this.isNotSelectedDocumentType = false
                                    this.age = "";
                                    this.keepData = false;
                                }
                                else {
                                    this.MaximDigitSuperatedDni = true;
                                    this.keepData = false;
                                }
                            }
                        }).then(() => NF.UI.Page.unblock());
                }
                else {
                    this.activeForm = false;
                    this.activeFormPersonNoExist = false;
                    this.nacimiento = null;
                    this.areaCode = "";
                    this.telephone = "";
                    this.email = "";
                    this.age = "0";
                    this.selectedLocality = null;
                    this.streetName = null;
                    this.numDept = null;
                    this.numDom = null;
                    this.piso = null;
                    this.gender = null;
                    this.genderId = null;
                    this.isPersonExist = true;
                    this.isNotSelectedDocumentType = false;
                    this.firstName = "";
                    this.lastName = "";
                    this.hasLocality = false;
                    this.lastDocumentTypeFromService = null;
                    this.keepData = false;
                    NF.UI.Page.unblock();
                }
            },

            CleanPersonDataForm: function () {
                if (this.numDoc == "") {
                    NF.UI.Page.blockCustom({ message: 'Limpiando datos..' });
                    this.activeForm = false;
                    this.activeFormPersonNoExist = false;
                    this.nacimiento = null;
                    this.areaCode = "";
                    this.telephone = "";
                    this.email = "";
                    this.age = "0";
                    this.selectedLocality = null;
                    this.streetName = null;
                    this.numDept = null;
                    this.numDom = null;
                    this.piso = null;
                    this.gender = null;
                    this.genderId = null;
                    this.isPersonExist = true;
                    this.isNotSelectedDocumentType = false;
                    this.firstName = "";
                    this.lastName = "";
                    this.hasLocality = false;
                    NF.UI.Page.unblock();
                }
            },

            isSelectedDocumentType: function () {
                this.isNotSelectedDocumentType = false
                this.docTypeSelected != null ? this.docTypeSelected.name.trim() != "CUIT" ? (this.isPerson = true, this.isJuridico = false) : (this.isJuridico = true, this.isPerson = false) : null
                if ((!this.hasChangedDocumentTypeBefore
                    && !this.isPersonWithSharedDocumentNumber
                    && this.lastDocumentTypeFromService != this.docTypeSelected.id)
                    || (!this.keepData
                        && this.lastDocumentTypeFromService != this.docTypeSelected.id)
                    || (!this.hasBupPerson
                        && this.lastDocumentTypeFromService != this.docTypeSelected.id)) {
                    this.nacimiento = null;
                    this.numDoc = ""
                    this.piso = "";
                    this.numDept = "";
                    this.numDom = "";
                    this.streetName = null;
                    this.isPersonExist = true;
                    this.hasLocality = false;
                    this.lastDocumentTypeFromService = null;

                    if (this.hasBupPerson) { this.hasChangedDocumentTypeBefore = true; }
                }
                this.keepData = false;
            },

            calcularEdad: function () {
                this.messageErrorAge = ""
                if (this.nacimiento) {
                    var today = new Date();
                    //primero preguntamos si nacimiento viene en formato DATE, si es si, va normal this.nacimiento
                    //si no : split('/').reverse().join('/'): Esto cambia el formato de la fecha de "dd/mm/yyyy" a "yyyy/mm/dd" para que JavaScript pueda interpretarla correctamente como un objeto Date.
                    var birthDate = (this.nacimiento instanceof Date && !isNaN(this.nacimiento)) ? this.nacimiento : new Date(this.nacimiento.split('/').reverse().join('/'));
                    var age = today.getFullYear() - birthDate.getFullYear();
                    var m = today.getMonth() - birthDate.getMonth();
                    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
                        age--;
                    };
                    this.age = age;
                    this.messageErrorAge = (this.age < 18) ? "La persona deberá ser mayor de 18 años" : "";
                }
                else {
                    this.age = 0;
                }
            },
            getInitData() {
                window.globalThis.dataLayer = window.globalThis.dataLayer || [];
                this.Bus.$on('get-step-one-data', () => this.Bus.$emit('step-one-data', this.$data))
                this.getDocumentType();
            }
        },
        watch: {
            nacimiento(newVal) {
                if (newVal != null || newVal != "") {
                    this.calcularEdad();
                }
            },
            areaCode(newVal) {
                if (newVal != null && newVal != "") {
                    clearTimeout(this.areaCodeTimeout);
                    this.areaCodeTimeout = setTimeout(() => {
                        this.getTelephoneValidation();
                    }, 800);
                }
            },
            telephone(newVal) {
                if (newVal != null && newVal != "") {
                    clearTimeout(this.telephoneTimeout);
                    this.telephoneTimeout = setTimeout(() => {
                        this.getTelephoneValidation();
                    }, 800);
                }
            },
            numDoc(newVal) {
                if (newVal == "") {
                    this.Bus.$emit('disableNextButton');
                    this.disable = true;
                    this.activeForm = false;
                    this.activeFormPersonNoExist = false;
                    this.nacimiento = null;
                    this.areaCode = "";
                    this.telephone = "";
                    this.email = "";
                    this.age = "0";
                    this.selectedLocality = null;
                    this.streetName = null;
                    this.numDept = null;
                    this.numDom = null;
                    this.piso = null;
                    this.gender = null;
                    this.genderId = null;
                    this.isPersonExist = true;
                    this.isNotSelectedDocumentType = false;
                    this.firstName = "";
                    this.lastName = "";
                    this.hasLocality = false;
                    NF.UI.Page.unblock();
                }

            },
            docTypeSelected(newVal, oldVal) {
                const newId = typeof newVal === 'object' && newVal !== null ? newVal.id : newVal;
                const oldId = typeof oldVal === 'object' && oldVal !== null ? oldVal.id : oldVal;

                if (newId == oldId) {
                    this.isSelectedDocumentType();
                }
            }
        },
        mounted() {
            var referente = sessionStorage.getItem("Referente");
            referente == 'null' || referente == null ? this.referente = null : this.referente = referente;

            this.getInitData();
        }
    });
